import { Link } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function CheckoutCancelPage() {
  return (
    <div className="section-padding">
      <div className="container-app max-w-2xl">
        <Card className="card-marketing">
          <CardContent className="py-16 text-center">
            <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mx-auto mb-6">
              <XCircle className="h-10 w-10 text-muted-foreground" />
            </div>
            <h1 className="font-heading text-2xl font-bold mb-2" data-testid="cancel-title">
              Checkout Cancelled
            </h1>
            <p className="text-muted-foreground mb-8">
              Your order has not been processed. Your cart items are still saved.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/cart">
                <Button className="btn-primary" data-testid="return-to-cart-btn">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Return to Cart
                </Button>
              </Link>
              <Link to="/catalog">
                <Button variant="outline" data-testid="continue-shopping-btn">
                  Continue Shopping
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
